function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.9634,
    r: 16,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3666 11.945H17.5228C17.7363 11.945 17.9212 11.8669 18.0775 11.7108C18.2335 11.5548 18.3116 11.3697 18.3116 11.1561V8.78909C18.3116 8.57544 18.2335 8.39054 18.0772 8.23423C17.9212 8.07823 17.7361 8 17.5225 8H14.3666C14.1529 8 13.968 8.07823 13.8119 8.23423C13.6557 8.39038 13.5776 8.57544 13.5776 8.78909V11.1561C13.5776 11.3697 13.6557 11.5548 13.8119 11.7108C13.968 11.8669 14.1529 11.945 14.3666 11.945Z",
    fill: "#052C42",
    style: {
      fill: "#052C42",
      fill: "color(display-p3 0.0196 0.1725 0.2588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6555 22.4361C19.4995 22.2799 19.3144 22.2019 19.1008 22.2019H18.3117V15.101C18.3117 14.8873 18.2336 14.7024 18.0776 14.5462C17.9213 14.3901 17.7364 14.312 17.5229 14.312H12.7889C12.5753 14.312 12.3904 14.3901 12.2342 14.5462C12.0781 14.7024 12 14.8873 12 15.101V16.679C12 16.8926 12.0781 17.0777 12.2342 17.2337C12.3904 17.3898 12.5753 17.4679 12.7889 17.4679H13.578V22.2019H12.7889C12.5753 22.2019 12.3904 22.2799 12.2342 22.4361C12.0781 22.5923 12 22.7772 12 22.9908V24.5688C12 24.7825 12.0781 24.9675 12.2342 25.1239C12.3904 25.2797 12.5753 25.3579 12.7889 25.3579H19.1008C19.3144 25.3579 19.4993 25.2797 19.6555 25.1239C19.8115 24.9675 19.8896 24.7825 19.8896 24.5688V22.9908C19.8896 22.7772 19.8119 22.5923 19.6555 22.4361Z",
    fill: "#052C42",
    style: {
      fill: "#052C42",
      fill: "color(display-p3 0.0196 0.1725 0.2588)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.5e55b32f4b127d65c2a9a0f69e6376be.svg";
export { ForwardRef as ReactComponent };